import apiClient from "../Config/Index";

const NotifyMeApi = {
    list: async (params) => {
        try {
            const response = await apiClient.get("/notifyme/list", { params });
            return { status: true, response: response.data };
        } catch (error) {
            return { status: false, error: error.response?.data || error.message };
        }
    },

    remove: async (id) => {
        try {
            const response = await apiClient.delete(`/notifyme/remove/${id}`);
            return { status: true, response: response.data };
        } catch (error) {
            return { status: false, error: error.response?.data || error.message };
        }
    }
};

export default NotifyMeApi;
